import React from "react" ;

import AppSidebarMenuItem from "../../Common/Sidebar/AppSidebarMenuItem";
import AppSidebarGroup from "../../Common/Sidebar/AppSidebarGroup";
import MessagingAppQuickMenu from "./MessagingAppQuickMenu";
import {Route, Switch} from "react-router-dom";
import MessagingSubmenu from "./MessagingSubmenu";
import {
    getMessagingRouterLink, PATH_HOME_ROOT,
    PATH_MESSAGING_MESSAGING,
    PATH_MESSAGING_ROOT
} from "root/Wieldy/routePaths";

import ScrollRails from "root/Wieldy/ApplicationModules/Common/Body/ScrollRails";
import AppSidebarHeader from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarHeader";
import ApprovalsAppSubmenu from "root/Wieldy/ApplicationModules/Approvals/Sidebar/ApprovalsAppSubmenu";

const MessagingAppSidebar= (props) =>
{
    return (
        <div className="dt-module__sidebar">

            <AppSidebarHeader iconName={props.iconName} title={props.title}>
                <MessagingAppQuickMenu />
            </AppSidebarHeader>

            { /* Sidebar Menu */}
            <div className="dt-module__sidebar-content ps-custom-scrollbar ps" style={{height: props.height}}>

                <ul className="dt-module-side-nav">

                    { /* Menu Item */}
                    <AppSidebarGroup title='View' default='messaging'>
                        <AppSidebarMenuItem link={getMessagingRouterLink('messaging')} title='My Messages' iconName='icon-chat' name='messaging' />
                    </AppSidebarGroup>

                    <Switch>
                        <Route path={PATH_MESSAGING_MESSAGING} render={(props) => <MessagingSubmenu {...props}/>}/>
                        <Route exact path={PATH_MESSAGING_ROOT} render={(props) => <MessagingSubmenu {...props}/>}/>
                        <Route exact path={PATH_HOME_ROOT} render={(props) => <MessagingSubmenu {...props}/>}/>
                    </Switch>

                </ul>

                <ScrollRails />
            </div>

        </div>
    ) ;
}

export default MessagingAppSidebar;
